import { render, staticRenderFns } from "./Shipping-Info.vue?vue&type=template&id=97dd9a60&scoped=true"
import script from "./Shipping-Info.vue?vue&type=script&lang=js"
export * from "./Shipping-Info.vue?vue&type=script&lang=js"
import style0 from "./Shipping-Info.vue?vue&type=style&index=0&id=97dd9a60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97dd9a60",
  null
  
)

export default component.exports